import { connect } from 'react-redux'

import UniversalMenuExplorer from '@components/groupOrders/UniversalMenuExplorer/UniversalMenuExplorer'

import coordinators from '@coordinators'
import presenters from '@presenters'
import services from '@services'
import { HandleError } from '@coordinators/composed'
import { AdminUser } from '@types'

type ReduxState = {
  user: AdminUser
}

const mapStateToProps = (state: ReduxState) => {
  const { user } = state
  const { lastLoggedInHq } = user

  return {
    hqId: lastLoggedInHq,
  }
}

const mapDispatchToProps = () => {
  const { GroupOrdersService, RestService, UIService, SettingsService } =
    services
  const {
    AsyncLoadDietaryAllergens,
    LoadSettings,
    RetryOnTimeout,
    SearchClientSettings,
    SearchUniversalExplorerMenus,
  } = coordinators
  const { pMapOptionAttributes } = presenters
  const {
    pRequestSearchGOMenusParams,
    pRequestSettings,
    pResponseGOMenus,
    pResponseGroupOrderClientSettings,
    pResponseSettings,
  } = presenters.Api

  const loadAllergens = AsyncLoadDietaryAllergens({
    RestService,
    SettingsService,
    pMapOptionAttributes,
    pRequestSettings,
    pResponseSettings,
    LoadSettings,
    RetryOnTimeout,
    HandleError,
  })

  const searchGOMenus = SearchUniversalExplorerMenus({
    RestService,
    pRequestSearchGOMenusParams,
    pResponseGOMenus: pResponseGOMenus as any,
    HandleError,
  })

  const searchClientSettings = SearchClientSettings({
    RestService,
    GroupOrdersService,
    HandleError,
    pResponseGroupOrderClientSettings,
  })

  const { displayFailureMessage } = UIService.FlashMessage

  return {
    displayFailureMessage,
    loadAllergens,
    searchGOMenus,
    searchClientSettings,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UniversalMenuExplorer)
